import { ProviderBuilder, EGenMode } from '@educraft/base';
import { BackScreen__Green } from './generators/BackScreen__Green';
import { BackScreen__Blue } from './generators/BackScreen__Blue';
import { Hodiny } from './generators/Hodiny';
import { KolickyVpravoVlevo } from './generators/KolickyVpravoVlevo';
import { Velikosti } from './generators/Velikosti';
import { Otoceni } from './generators/Otoceni';
import { VpravoVlevo } from './generators/VpravoVlevo';
import { Dvere } from './generators/Dvere';
import { KartyDopln } from './generators/KartyDopln';
import { Tetris } from './generators/Tetris';
import { Skladacka } from './generators/Skladacka';
import { Multiplication } from './generators/Multiplication';
import { Pocitani5 } from './generators/Pocitani5';
import { Rozklad } from './generators/Rozklad';
import { PodSebou } from './generators/PodSebou';
import { NebePekloRaj } from './generators/NebePekloRaj';
import { Pocty__1 } from './generators/Pocty__1';
import { Pocty__2 } from './generators/Pocty__2';
import { Jednotky } from './generators/Jednotky';
import { Klavesnice } from './generators/Klavesnice';
import { Gluckhaus } from './generators/Gluckhaus';
import { Sachy } from './generators/Sachy';
import { Ludo } from './generators/Ludo';
import { Test__1, Test__2, Test__3, Test__4 } from './generators/Test';
import { RozvrhHodin__1, RozvrhHodin__2, Rozvrhhodin__3 } from './generators/Rozvrh_hodin';
import { LCD_Tabulka } from './generators/LCD_Tabulka';
import { Pexeso } from './generators/Pexeso';
import { CernyPetr } from './generators/CernyPetr';
import { Dobble } from './generators/Dobble';
import { Monopoly } from './generators/Monopoly';
import { HraciKarty } from './generators/HraciKarty';
import { Vajicka } from './generators/Vajicka';
import { Trimino } from './generators/Trimino';
import { Obrysy } from './generators/Obrysy';
import { Stinohra } from './generators/Stinohra';
import { Darky } from './generators/Darky';

export function registerLayoutImage(builder: ProviderBuilder) {
  builder.add(EGenMode.LayoutImage, BackScreen__Green, 'Image.BackScreen__Green');
  builder.add(EGenMode.LayoutImage, BackScreen__Blue, 'Image.BackScreen__Blue');
  builder.add(EGenMode.LayoutImage, Hodiny, 'Image.Hodiny');
  builder.add(EGenMode.LayoutImage, KolickyVpravoVlevo, 'Image.KolickyVpravoVlevo');
  builder.add(EGenMode.LayoutImage, Velikosti, 'Image.Velikosti');
  builder.add(EGenMode.LayoutImage, Otoceni, 'Image.Otoceni');
  builder.add(EGenMode.LayoutImage, VpravoVlevo, 'Image.VpravoVlevo');
  builder.add(EGenMode.LayoutImage, Dvere, 'Image.Dvere');
  builder.add(EGenMode.LayoutImage, KartyDopln, 'Image.KartyDopln');
  builder.add(EGenMode.LayoutImage, Tetris, 'Image.Tetris');
  builder.add(EGenMode.LayoutImage, Skladacka, 'Image.Skladacka');
  builder.add(EGenMode.LayoutImage, Multiplication, 'Image.Multiplication');
  builder.add(EGenMode.LayoutImage, Pocitani5, 'Image.Pocitani5');
  builder.add(EGenMode.LayoutImage, Rozklad, 'Image.Rozklad');
  builder.add(EGenMode.LayoutImage, PodSebou, 'Image.PodSebou');
  builder.add(EGenMode.LayoutImage, NebePekloRaj, 'Image.NebePekloRaj');
  builder.add(EGenMode.LayoutImage, Pocty__1, 'Image.Pocty__1');
  builder.add(EGenMode.LayoutImage, Pocty__2, 'Image.Pocty__2');
  builder.add(EGenMode.LayoutImage, Test__1, 'Image.Test__1');
  builder.add(EGenMode.LayoutImage, Test__2, 'Image.Test__2');
  builder.add(EGenMode.LayoutImage, Test__3, 'Image.Test__3');
  builder.add(EGenMode.LayoutImage, Test__4, 'Image.Test__4');
  builder.add(EGenMode.LayoutImage, RozvrhHodin__1, 'Image.RozvrhHodin__1');
  builder.add(EGenMode.LayoutImage, RozvrhHodin__2, 'Image.RozvrhHodin__2');
  builder.add(EGenMode.LayoutImage, Rozvrhhodin__3, 'Image.RozvrhHodin__3');
  builder.add(EGenMode.LayoutImage, Pexeso, 'Image.Pexeso');
  builder.add(EGenMode.LayoutImage, CernyPetr, 'Image.CernyPetr');
  builder.add(EGenMode.LayoutImage, Dobble, 'Image.Dobble');
  builder.add(EGenMode.LayoutImage, Monopoly, 'Image.Monopoly');
  builder.add(EGenMode.LayoutImage, HraciKarty, 'Image.HraciKarty');
  builder.add(EGenMode.LayoutImage, Vajicka, 'Image.Vajicka');
  builder.add(EGenMode.LayoutImage, Trimino, 'Image.Trimino');
  builder.add(EGenMode.LayoutImage, Ludo, 'Image.Ludo');
  builder.add(EGenMode.LayoutImage, Sachy, 'Image.Sachy');
  builder.add(EGenMode.LayoutImage, Gluckhaus, 'Image.Gluckhaus');
  builder.add(EGenMode.LayoutImage, Jednotky, 'Image.Jednotky');
  builder.add(EGenMode.LayoutImage, Klavesnice, 'Image.Klavesnice');
  builder.add(EGenMode.LayoutImage, Obrysy, 'Image.Obrysy');
  builder.add(EGenMode.LayoutImage, Stinohra, 'Image.Stinohra');
  builder.add(EGenMode.LayoutImage, Darky, 'Image.Darky');
}
